<template>
  <div class="detail">
    <!-- Default type: DetailList with question/answer sections -->
    <DetailList
      v-if="icon.type === 'default'"
      :list-data="selectRelated.testimonies"
      :lock-icon="icon.locked_testimony"
      :had-found-exhibit-ids="hadFoundExhibitIds"
      :had-found-related-ids="hadFoundRelatedIds"
      :had-found-timeline-ids="hadFoundTimelineIds"
      :had-found-position-ids="hadFoundPositionIds"
      :tutorial-highlight-clue="tutorialHighlightClue"
    />

    <!-- Collapse type: Collapsible interface -->
    <Collapse
      v-else
      :list-data="selectRelated.testimonies"
      :book-close-icon="icon.question_close_icon"
      :book-open-icon="icon.question_open_icon"
    />
  </div>
</template>

<script>
import DetailList from '../tools/detailList.vue';
import Collapse from '@/components/common/Collapse';

/**
 * TestimonySection Component following SOLID principles
 * Single Responsibility: Display and manage testimony content
 * Open/Closed: Extensible through different display modes (default/collapse)
 * Liskov Substitution: DetailList and Collapse can be used interchangeably
 * Interface Segregation: Clean interface for testimony display
 * Dependency Inversion: Depends on child components abstractions
 */
export default {
  name: 'TestimonySection',

  components: {
    DetailList,
    Collapse
  },

  props: {
    selectRelated: {
      type: Object,
      required: true,
      default: function() { return { testimonies: [] }; }
    },
    icon: {
      type: Object,
      required: true,
      default: function() { return {}; }
    },
    hadFoundExhibitIds: {
      type: Array,
      default: function() { return []; }
    },
    hadFoundRelatedIds: {
      type: Array,
      default: function() { return []; }
    },
    hadFoundTimelineIds: {
      type: Array,
      default: function() { return []; }
    },
    hadFoundPositionIds: {
      type: Array,
      default: function() { return []; }
    },
    tutorialHighlightClue: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="scss" scoped>
.detail {
  position: relative;
  margin: 1rem;
}

// Responsive design
@media (max-width: 768px) {
  .detail {
    margin: 0.5rem;
  }
}
</style>
